import Table from "Shared/components/DataTable/Table"
import restClient from 'Shared/hooks/restClient'

const WorkflowsDatatable = () => {
  const handleTableClick = (e) => {
    if(e.target.classList.contains('restore-workflow')) {
      const workflowId = e.target.dataset.workflowId
      
      if (window.confirm('Are you sure you want to restore this automation?')) {
        restClient.post(`/api/workflows/${workflowId}/restore`).then(() => {
          window.location.href = '/admin/workflows'
        })
      }
    }
  }

  const tableProps = {
    table: 'workflows',
    language: { emptyTable: "You've not set up any automations yet." },
    includeTypeParam: true,
    onClick: handleTableClick,
  }

  return (
    <div className="section">
      <div className="box">
        <div className="header">
          <h2>Your automations</h2>
        </div>

        <Table {...tableProps} />
      </div>
    </div>
  )
}

export default WorkflowsDatatable
